export const ApiSignalUrl = "api/signal";
export const ApiAuthRefreshUrl = "api/auth/refresh";
